import { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../firebase/config";
import { approveFaculty, disableFaculty } from "../control/FacultyService";
import { Container, Table, Button, Dropdown } from "react-bootstrap";

function FacultyApprovalDashboard() {
  const [pendingFaculty, setPendingFaculty] = useState([]);

  useEffect(() => {
    const fetchPendingFaculty = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const pending = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(user => !user.role.includes("student") && (user.approved === false));

      setPendingFaculty(pending);
    };

    fetchPendingFaculty();
  }, []);

  const handleApprove = async (facultyId) => {
    try {
      await approveFaculty(facultyId);
      setPendingFaculty(prev => prev.filter(faculty => faculty.id !== facultyId));
    } catch (error) {
      console.error("Error approving faculty:", error);
    }
  };

  return (
    <Container>
      <Table striped bordered hover>
        <thead>
        <tr>
          <th>Email</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {pendingFaculty.map((faculty, index) => (
          <tr key={index}>
            <td>{faculty.email}</td>
            <td>
              {/* Dropdown button with custom green styling */}
              <Dropdown>
                <Dropdown.Toggle
                  className="actionButton"
                >
                  Actions
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleApprove(faculty.id)}>
                    Approve
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => {
                    console.log("Disabling faculty with ID:", faculty.id);
                    disableFaculty(faculty.id);
                  }}>
                    Disable
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
        ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default FacultyApprovalDashboard;